module.exports = __webpack_public_path__ + "static/media/SF_UI_Display_Regular.b7d5db94.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF_UI_Display_Regular.woff
// module id = 212
// module chunks = 0